import React from "react";
import { Filter, Sparkles } from "lucide-react";

export default function SegmentInsightStep({
  segmentDef, insightDef, segment, onSegmentChange, insightId, onInsightChange,
  segmentStepTitle = "Step 6a — Build a Segment",
  insightStepTitle = "Step 6b — Build a Calculated Insight",
}) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-heading font-semibold text-white mb-1 flex items-center gap-2"><Filter className="w-4 h-4 text-indigo-400" /> {segmentStepTitle}</h3>
        <p className="text-sm text-slate-400 mb-3">{segmentDef.description}</p>
        <div className="flex flex-wrap items-center gap-2" data-testid="segment-builder">
          <select
            value={segment.attribute || ""} onChange={(e) => onSegmentChange({ ...segment, attribute: e.target.value })}
            data-testid="segment-attribute-select"
            className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
          >
            <option value="">Attribute...</option>
            {segmentDef.attributes.map((a) => <option key={a} value={a}>{a}</option>)}
          </select>
          <select
            value={segment.operator || ""} onChange={(e) => onSegmentChange({ ...segment, operator: e.target.value })}
            data-testid="segment-operator-select"
            className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
          >
            <option value="">Operator...</option>
            {segmentDef.operators.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
          <input
            value={segment.value || ""} onChange={(e) => onSegmentChange({ ...segment, value: e.target.value })}
            placeholder="Value..." data-testid="segment-value-input"
            className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white w-32 focus:outline-none focus:ring-1 focus:ring-indigo-400"
          />
        </div>
      </div>
      <div>
        <h3 className="font-heading font-semibold text-white mb-1 flex items-center gap-2"><Sparkles className="w-4 h-4 text-indigo-400" /> {insightStepTitle}</h3>
        <p className="text-sm text-slate-400 mb-3">{insightDef.prompt}</p>
        <div className="space-y-2">
          {insightDef.options.map((o) => (
            <button
              key={o.id} onClick={() => onInsightChange(o.id)} data-testid={`insight-option-${o.id}`}
              className={`w-full text-left text-sm px-4 py-2.5 rounded-lg border transition-colors ${
                insightId === o.id ? "border-indigo-400 bg-indigo-400/10 text-indigo-200" : "border-white/10 text-slate-300 hover:border-white/25"
              }`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
